// Reference https://legacy.pro.balmjs.com/#/plugins/api-model
import authApis from "./auth";
import baseApis from "./base";
import voiceApis from "./voice";

export default {
  crud: {
    create: "add",
    read: {
      list: "index",
      detail: "info",
    },
    update: "edit",
    delete: "delete",
  },
  urlToCamelCase: true,
  apis: [...authApis, ...baseApis, ...voiceApis],
  //   debug: ''
};
